import HomepassBookingForm from './homepass-booking';
export default HomepassBookingForm;